module.exports = __webpack_public_path__ + "assets/favicon.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/favicon.ico
// module id = 1660
// module chunks = 7